import sizes from './Sizes';
import colors from './Colors';

const Fonts = {
  h1: {
    fontFamily: 'CircularStd',
    fontSize: sizes.h1,
    lineHeight: '150%',
  },
  h2: {
    fontFamily: 'CircularStd',
    fontSize: sizes.h2,
    lineHeight: '150%',
  },
  h3: {
    fontFamily: 'CircularStd',
    fontSize: sizes.h3,
    lineHeight: '150%',
  },
  h4: {
    fontFamily: 'CircularStd',
    fontSize: sizes.h4,
    lineHeight: '150%',
  },

  h5: {
    fontFamily: 'CircularStd',
    fontSize: sizes.h5,
    lineHeight: '150%',
  },
  h6: {
    fontFamily: 'geomanist-book',
    fontSize: sizes.h6,
    lineHeight: '150%',
  },

  header: {
    fontFamily: 'CircularStd',
    fontSize: sizes.header,
    lineHeight: '150%',
    letterSpacing: 0.5,
    color: colors.black,
  },
  subHeader: {
    fontFamily: 'clanpro-thin',
    fontSize: sizes.subHeader,
    lineHeight: '150%',
    letterSpacing: 0.5,
    color: colors.black,
  },

  title: {
    fontFamily: 'CircularStd',
    fontSize: sizes.title,
    lineHeight: '150%',
    letterSpacing: 0.5,
    color: colors.black,
  },

  subTitle: {
    fontFamily: 'CircularStd',
    fontSize: sizes.subTitle,
    lineHeight: '150%',
    letterSpacing: 0.5,
    color: colors.black,
  },

  semibold: {
    fontFamily: 'CircularStd',
    fontWeight: 100,
  },

  bold: {
    fontFamily: 'CircularStd',
    fontWeight: '700',
  },

  light: {
    fontFamily: 'geomanist-book',
  },

  italic: {
    fontStyle: 'italic',
  },
  strikethrough: {
    textDecoration: 'line-through',
  },
  underline: {
    textDecoration: 'underline',
  },

  normal: {
    fontFamily: 'geomanist-book',
    color: colors.black,
    fontWeight: 600,
    fontSize: 14,
  },

  default: {
    fontFamily: 'geomanist-book',
    // fontSize: sizes.body,
    color: colors.black,
    fontWeight: 600,
    fontSize: 14,
  },

  body: {
    fontFamily: 'geomanist-book',
    // fontSize: sizes.body,
    lineHeight: '200%',
    color: colors.black,
    fontSize: 14,
  },
  body2: {
    fontFamily: 'geomanist-book',
    // fontSize: sizes.body,
    lineHeight: '200%',
    color: colors.black,
    fontSize: 14,
  },

  caption: {
    fontFamily: 'geomanist-book',
    fontSize: sizes.caption,
  },
  small: {
    fontSize: sizes.small,
    fontWeight: 600,
    lineHeight: '200%',
    color: colors.darkGray,
  },
  button: {
    fontSize: sizes.button,
    color: colors.white,
  },
};

export default Fonts;
